// Color & Size filter options are loaded live from the admin-managed attributes
// (see Product.jsx). Price is a range slider. Only the static, non-attribute
// filters live here.
export const singleFilter = [
  {
    id: "stock",
    name: "Availability",
    options: [
      { value: "in_stock", label: "In Stock" },
      { value: "out_of_stock", label: "Out Of Stock" },
    ],
  },
  {
    id: "disccout",
    name: "Discount",
    options: [
      { value: "1", label: "On Sale (any offer)" },
      { value: "10", label: "10% and above" },
      { value: "20", label: "20% and above" },
      { value: "30", label: "30% and above" },
      { value: "40", label: "40% and above" },
      { value: "50", label: "50% and above" },
    ],
  },
];

export const sortOptions = [
  { name: "Newest First", query: "newest", current: false },
  { name: "Price: Low to High", query: "price_low", current: false },
  { name: "Price: High to Low", query: "price_high", current: false },
  { name: "Discount: High to Low", query: "discount", current: false },
];
